module.exports = __webpack_public_path__ + "img/2Y.495d3e4c.jpg";